import React, {useState, useEffect, useRef} from 'react';
import { useDispatch } from 'react-redux';
import {useLocation} from 'react-router-dom';
import Select from 'react-select';
import {
  Button,
  Card,
  CardGroup,
  Col,
  Container,
  Form,
  InputGroup,
  Row
} from 'react-bootstrap';
// import '../../assets/css/pages/form.css';
// import { SpinnerRoundFilled } from 'spinners-react';
import {LoaderMedium} from './../../components/loader';
import ValidationHelper from '../../helper/validation';
import {RSRegisterStyle} from "../../config/react-select";
//Axios Call
import {login_register} from '../../actions/action-creators/auth';
import {error_api_call} from '../../actions/action-creators/common';
import {SetMetaData} from './../../helper/page-title';
import { roleData } from '../../data/formData/option';
//State
const inputDefaultValue = {
  email: '',
  password: '',
  role_id: ''
};

const Login = () => {
  SetMetaData("Login", "", "");
  const location = useLocation();
    const isMounted = useRef(null);
  // const [currentStep, setCurrentStep] = useState(2);//1=>Initial,2=>Login,3=>Register,4=>Verification
  //Store Data
  // const authReduxData = useSelector(state => state.auth);
  const dispatch = useDispatch()
  const [inputFields, setFields] = useState(inputDefaultValue);
  const [securePassword, setsecurePassword] = useState(true);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [isLoginProcess, setIsLoginProcess] = useState(false);
  const [isError, setIsError] = useState('');
  const [redirectUri, setRedirectUri] = useState('');
  //Redirection Url
  useEffect(() => {
    const urlHandling = () => {
      try{
        // const urlQuryString = window.location.search;
        const urlQuryString = location.search;
        const urlParam = new URLSearchParams(urlQuryString);
        const urlRedirect = urlParam.get('redirect_uri');
        if(urlRedirect !== '' && urlRedirect !== null){
          setRedirectUri(urlRedirect);
        }
      }catch(e){
        error_api_call({error: `auth/login|urlHandling|${e}`});
      }
    }
    urlHandling();
  }, []);// eslint-disable-line react-hooks/exhaustive-deps
  //Update Input Box
  const _onChangeText = (attrName, value) => {
    try{
      setIsError('');
      let fields = {...inputFields};
      if(attrName !== 'role_id'){
        value = value.replace(/ /g, '');
      }
      fields[attrName] = value;
      setFields({...fields});
    }catch(e){
      error_api_call({error: `auth/login|_onChangeText|${JSON.stringify(inputFields)}|${e}`});
    }
  }
  //Input Validation:Use to Toggle Button: Disable-true|false
  useEffect(()=>{
    //Validate Input
    const _validate = () => {
      // if (!didMount) return null;
      let fields = {...inputFields};
      try{
        var validators = {};
        validators['role_id'] = 'required';
        validators['password'] = 'required|password|min:8|max:30';
        validators['email'] = 'required|email|min:7|max:100';
        const validation = ValidationHelper.validation(fields, validators).error;
        setSubmitDisabled(validation.length ? true : false);
        return validation.length ? false : true;
      }catch(e){
        error_api_call({error: `auth/login|_validate|${JSON.stringify(inputFields)}|${e}`});
      }
    };
    _validate();
    isMounted.current = true;
    return () => {
      // executed when unmount
      isMounted.current = false;
    }
  }, [inputFields]);// eslint-disable-line react-hooks/exhaustive-deps
  //Toggle Show-Hide Password
  const _showHidePass = () => {
    setsecurePassword(!securePassword)
  };
  //Login-Register User
  const _loginRegister = async() => {
    //Validation:Already done
    //Show Loader
    try{
      var formData = {...inputFields};
      setIsLoginProcess(true);
      setIsError('');
      formData.role_id = formData.role_id.id
      dispatch(login_register('login/email', formData, cb_login => {
        // console.log(cb_login, 'cb_login')
        if (isMounted.current) {
          if(cb_login.status === 200){
            // if(cb_login.data.validity.success){
            //   //Get first hostname from redirection url
            //   const redirectUriArr = redirectUri.split('/');
            //   const redirectServ = redirectUriArr.length > 0 ? redirectUriArr[0] : '';
            //   if((cb_login.data.validity.port === 0 && cb_login.data.validity.ss === 0)
            //     || (redirectServ === 'port' && cb_login.data.validity.port === 0)
            //     || (redirectServ === 'social-startup' && cb_login.data.validity.ss === 0)
            //   ){//If both service expired
            //     window.location.href = '/pay';
            //   }else{
            //     window.location.href = redirectUri ? `${redirectUri}` : "/port";
            //   }
            // }else{
              window.location.href = redirectUri ? `${redirectUri}` : "/";
            // }
              // console.log('port', redirectUri)
              // return;
              // window.location.href = '/port';
              // window.location.href = redirectUri ? `${redirectUri}` : "/port";
              // window.location.href = redirectUri ? `${redirectUri}` : "/";
            // if(cb_login.data.data.is_verified === 1
            //   || cb_login.data,data.is_verified === 3
            // ){
            //   // window.location.href = redirectUri ? `/${redirectUri}` : "/";
            // }else{
            //   // window.location.href = redirectUri ? `/verification?redirect_uri=${redirectUri}` : '/verification';
            //   // setCurrentStep(4);//Verification
            //   // window.location.href = 'port';
            // }
          }else{
            setIsError(cb_login.msg);
          }
          setIsLoginProcess(false);   
        }
      }));
    }catch(e){
      console.log(e)
    //   setIsError('Error Logging In/Registering! Please Try Again');
        setIsError('Error Logging In! Please Try Again');
      setIsLoginProcess(false);
      error_api_call({error: `auth/login|_loginRegister|${JSON.stringify(inputFields)}|${e}`});
    }
  }
  //Forget Password Redirect
  // const _forgotPassword = (e) => {
  //   e.preventDefault();
  //   if(ValidationHelper.validateNumber(inputFields.user_name)){
  //     window.location.href = `/reset-password?user_name=${inputFields.user_name}&redirect_uri=${redirectUri}`;
  //   }else{
  //     window.location.href = `/reset-password?redirect_uri=${redirectUri}`;
  //   }
  // }

  return (
    <main id="main">
    <div className="align-items-center login-form content-wrapper">
      <Container style={{minHeight: '88vh'}}>
        <Row className="justify-content-center">
          <Col md="7" lg="4">
            <CardGroup>
              <Card className="p-2 pt-0">
                <Card.Body className="p-4">
                <form name="login" id="login">
                    <div className="text-center">
                        <img src={require("../../assets/images/logo/logo.jpg")} alt="Logo" className="img-fluid w-200p mb-3" />
                    </div>
                    <div className="mb-4">
                        <h1 className="text-center">Login</h1>
                    </div>
                    {/* <p className="text-muted text-center">Sign In to your account</p> */}
                    {/* Role Id */}
                    <InputGroup className="mb-3">
                        <InputGroup.Text><i className="mdi mdi-18px mdi-account"></i></InputGroup.Text>
                        <div className="select-cont">
                            <Select
                                // isDisabled={true}
                                placeholder={"Role"}
                                options={roleData} 
                                // defaultValue={inputFields.role_id}
                                value={inputFields.role_id}
                                onChange={(value) => _onChangeText('role_id', value, 'select')}
                                getOptionLabel ={(option) => option.role}
                                getOptionValue ={(option) => option.id}
                                // styles={RSInputStyle}
                                menuPlacement="auto"
                                menuPosition={'fixed'}
                                // components={{
                                //     ValueContainer: CustomValueContainer
                                // }}
                                styles={RSRegisterStyle}
                                isDisabled={isLoginProcess ? true : false}
                                // className="is-valid"
                            />
                        </div>
                    </InputGroup>
                    {/* Email */}
                    <div className="mb-3">
                      <InputGroup>
                        <InputGroup.Text><i className="mdi mdi-18px mdi-email"></i></InputGroup.Text>
                        <Form.Control 
                          type="email" 
                          placeholder="Email" 
                          autoComplete="user_name" 
                          value={inputFields.email}
                          onChange={(event) => _onChangeText('email', event.target.value)}
                          maxLength={100}
                        //   readOnly={currentStep !== 1 || isLoginProcess ? true : false}
                            readOnly={isLoginProcess ? true : false}
                        />
                      </InputGroup>
                      {/* <p className="input-info">Space Not Allowed</p> */}
                    </div>
                    <>
                      <div className="mb-3">
                        <InputGroup>
                            <InputGroup.Text><i className="mdi mdi-18px mdi-lock"></i></InputGroup.Text>
                          <Form.Control 
                            type={securePassword ? "password" : "text"}
                            placeholder="Password" 
                            autoComplete="current-password" 
                            value={inputFields.password}
                            onChange={(event) => _onChangeText('password', event.target.value)}
                            maxLength={30}
                            readOnly={isLoginProcess ? true : false}
                          />
                          {inputFields.password !== "" &&
                            <i className={`mdi mdi-18px icon-eye ms-3 ${securePassword ? 'mdi-eye' : 'mdi-eye-off'}`} onClick={() => _showHidePass()}></i>
                          }
                        </InputGroup>
                        {/* <p className="input-info">Minimum 6 Characters, Maximum 30 Characters</p> */}
                      </div>
                    </>
                    <Col xs="12">
                      <a href={`/reset-password?email=${inputFields.email}`}>
                      <p className="link mb-0">
                        Forgot password?
                      </p>
                      </a>
                    </Col>
                    <Row className='mt-4'>
                      {isError &&
                        (<Col xs="12" className="text-center">
                            <div className="alert alert-danger" role="alert">
                                {isError}
                            </div>
                        </Col>)
                        }
                      <Col xs="12" className="text-center d-flex justify-content-center">
                        {isLoginProcess ? 
                          <Button
                            title="Submit"
                            disabled={true}
                            color={'primary'}
                            className="bg-color-blue fs-6 d-flex justify-content-center"
                          >
                            <LoaderMedium size={20} />
                            &nbsp;Logging...
                          </Button>
                          : 
                          <Button
                            type="submit"
                            disabled={submitDisabled}
                            onClick={() => _loginRegister()}
                            color={"primary"}
                            className="px-4 bg-color-blue fs-6"
                          >Login</Button>
                        }
                      </Col>
                      <Col xs="12" className="text-right mt-4">
                        <p className="link mb-0">
                          By Logging, I agree to the <a href={`${process.env.REACT_APP_DOMAIN}privacy-policy`} target="_blank" rel="noreferrer">privacy policy</a> and <a href={`${process.env.REACT_APP_DOMAIN}terms-and-conditions`}  target="_blank" rel="noreferrer">terms and conditions</a>
                        </p>
                      </Col>
                    </Row>
                  </form>
                </Card.Body>
              </Card>
            </CardGroup>
          </Col>
        </Row>
      </Container>
    </div>
    </main>
  )
}

export default Login
